import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import Datepicker from 'vuejs-datepicker';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';
// Service
import AdminService from '@/core/services/admin.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    Datepicker,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class EditAdminsComponent extends Vue {

  adminService: any = new AdminService();
  sidebarService: any = new SidebarService();
  genericErr: any = [];
  roleList: any = [];
  companyList: any = [];
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  modal: boolean = false;
  error: boolean = false;
  name: string = "";
  surname: string = "";
  birthdate: string = "";
  email: string = "";
  password: string = "";
  confirm_password: string = "";
  company: string = "";
  permissions: string = "";
  companies: string = "";
  manuallyPassword: boolean = false;

  mounted (){
    const _ = this;
    _.getById();
    _.getRoles();
    _.getCompanies();
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  getRoles(){
    const _ = this;
    _.isLoading = true;
    _.adminService.getRoles().then((data: any) => {
      _.roleList = data['data'].roles;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      _.isLoading = false;
    })
  }

  getCompanies(){
    const _ = this;
    _.isLoading = true;
    _.adminService.getCompanies().then((data: any) => {
      _.companyList = data['data'].companies;
      _.companyList.sort(function(a, b) {
        var textA = a.name.toLowerCase();
        var textB = b.name.toLowerCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      _.isLoading = false;
    })
  }

  edit(){
    const _ = this;
    let user = {
      name: _.name,
      surname: _.surname,
      email: _.email,
      birthdate: _.birthdate,
      companyId: _.companies,
      roleId: 3
    };
    console.log(user);
    let user_id: any = location.href.split("/");
    user_id = user_id[5];
    // TODO: Create validations to password != '' && password == confirm_password
    if(_.manuallyPassword){
      user.password = _.password;
      user.confirm_password = _.confirm_password;
      if(_.password == ''){
        _.genericErr.push("La contraseña es necesaria");
        return;
      }
      if(_.password.length < 6 && _.password != ''){
        _.genericErr.push("La constraseña debe tener minimo 6 caracteres");
        return;
      }
      if(_.password != _.confirm_password ){
        _.genericErr.push("Las constraseñas no coinciden");
        return;
      }
    }
    _.isLoading = true;
    _.adminService.edit(user, user_id).then((data: any) => {
      _.isSuccess = true;
      _.isErrorServer = false;
      _.error = false;
      _.modal = true;
      setTimeout(() => {
        _.isLoading = false;
        _.$router.push('/reporters');
      }, 1500)
    })
    .catch((err: any) => {
      _.modal = true;
      _.error = true;
      _.isErrorServer = true;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  getById(){
    const _ = this;
    let user_id: any = location.href.split("/");
    user_id = user_id[5];
    _.isLoading = true;
    _.adminService.getById(user_id).then((data: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
      _.name = data["data"].user.name;
      _.email = data["data"].user.email;
      _.surname = data["data"].user.surname;
      _.birthdate = data["data"].user.birthdate;
      _.companies = data["data"].user.companyId;
      _.permissions = data["data"].user.roleId;
    })
    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        _.logInModal = true;
        console.log(_.logInModal, '_.logInModal')
      }
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  validations(email = ''){
    const _ = this;
    _.genericErr = [];
    let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(email == ''){
      _.genericErr.push("Por favor escribe un correo");
    }
    if(_.genericErr.length > 0){
      _.modal = true;
      _.error = true;
      return;
    }
    _.edit()
  }
}
